var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('share-links',{attrs:{"image-url":_setup.heroImageUrl,"share-url":_setup.ltkShareUrl,"caption":_setup.ltkCaption,"is-runway":_vm.isRunway}})
}
var staticRenderFns = []

export { render, staticRenderFns }